import { Box, Stack, Typography } from "@mui/material"
import BaseImage from "../BaseImage"
import BaseLink from "../BaseLink"
import { NoDataComponent } from "../ReactDataTable"

const statusStyles = {
  PENDING: { bg: '#FFF3CD', color: '#856404', label: 'Unpaid' },
  COMPLETED: { bg: '#D4EDDA', color: '#155724', label: 'Completed' },
  EXPIRED: { bg: '#F8D7DA', color: '#721C24', label: 'Expired' },
  CANCELLED: { bg: '#E2E3E5', color: '#383D41', label: 'Cancelled' },
  FAILED: { bg: '#F8D7DA', color: '#721C24', label: 'Failed' },
}

const PatientList = ({ data, onRowClicked }) => {
  return (
    <Stack
      sx={{
        display: { xs: 'block', md: 'none' }
      }}
      direction={'column'}
      spacing={'8px'}
    >
      {data.map(((item, index) => {
        const isPending = item?.patientType === 'pending'
        return (
          <Box
            key={`${item?.id}-${index}`}
            onClick={isPending ? () => onRowClicked?.(item) : undefined}
            sx={{
              borderRadius: '8px',
              border: '1px solid',
              borderColor: 'primary.lightGray',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
              bgcolor: isPending ? '#FFF3D3' : 'white',
              cursor: isPending ? 'pointer' : undefined,
            }}
          >
            <Box
              sx={{
                borderBottom: '1px solid',
                borderColor: 'primary.lightGray',
                padding: '12px'
              }}
            >
              <Typography variant="body" color="primary.darkGray" fontFamily="monospace">
                {item?.kitCode}
              </Typography>
            </Box>
            <Box
              sx={{
                padding: '16px',
                borderRadius: '0 0 8px 8px'
              }}
            >
              <Box sx={{ display: 'flex' }}>
                {!isPending && (
                  <BaseImage
                    sx={{
                      minWidth: '40px',
                      width: '40px',
                      height: '40px',
                    }}
                    sximage={{
                      borderRadius: '50%'
                    }}
                    src={item?.avatarUrl || '//ssl.gstatic.com/accounts/ui/avatar_2x.png'}
                    alt='user-avatar'
                  />
                )}
                <Box sx={{ ml: !isPending ? '10px' : 0 }}>
                  <Typography variant="h3">
                    {item?.name}
                  </Typography>
                  <Typography variant="body" color='primary.darkGray' sx={{ wordBreak: "break-word" }}>
                    {item?.email}
                  </Typography>
                  {!isPending ? (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        mt: '4px'
                      }}
                    >
                      <Typography variant="subText">
                        In Review: {item?.reviewCount}
                      </Typography>
                      <Typography variant="subText">
                        Total Reports: {item?.totalReportCounts}
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ mt: '4px' }}>
                      <Typography variant="subText" color="primary.darkGray">
                        Created: {item?.createdAt
                          ? new Date(item.createdAt).toLocaleDateString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric',
                              hour: 'numeric',
                              minute: '2-digit',
                            })
                          : '-'}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                borderTop: '1px solid',
                borderColor: 'primary.lightGray',
                padding: '12px',
                display: 'flex',
                justifyContent: 'center',
                textDecoration: isPending ? 'none' : 'underline',
                color: isPending ? undefined : "primary.mainBlue"
              }}
            >
              {isPending ? (() => {
                const style = statusStyles[item?.status] || statusStyles.PENDING;
                return (
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 1.5,
                      py: 0.5,
                      borderRadius: '4px',
                      backgroundColor: style.bg,
                      color: style.color,
                      fontSize: '12px',
                      fontWeight: 500
                    }}
                  >
                    {style.label}
                  </Box>
                );
              })() : (
                <BaseLink to={`/patient/${item?.id}`}>
                  <Typography variant="body" color="primary.mainBlue">
                    Reports
                  </Typography>
                </BaseLink>
              )}
            </Box>
          </Box>
        )
      }))}
      {data && data.length === 0 && (
        <NoDataComponent />
      )}
    </Stack>
  )
}

export default PatientList
